import {
  Component, OnChanges,
  AfterViewInit, SimpleChanges, Input, Output, EventEmitter, HostBinding,
  ElementRef, Renderer2, ViewChild,
} from '@angular/core';

import { OverlayPanelComponent } from '@otas/utils/custom-components/overlay-panel/overlay-panel.component';
import * as _ from 'underscore';
import { Subscription } from 'rxjs';
import { VIRTUAL_KEYBOARD_LAYOUT } from '@otas/utils/custom-components/virtual-keyboard/keyboard-layout';
import { CurrentUser } from '@otas/model/current-user';
import { IndicInputDirective } from './indic-input.directive';
import { ManglishConverterDirective } from '@otas/utils/directives/manglish/manglish-converter.directive';
@Component({
  selector: 'indic-input',
  templateUrl: './virtual-keyboard.component.html',
  styleUrls: ['./virtual-keyboard.component.css'],
  standalone: false
})
export class VirtualKeyboardComponent implements OnChanges, AfterViewInit/*, ControlValueAccessor */ {

  @Input() type = 'text';
  @Input() placeholder: string;
  @Input() parentEl: ElementRef;
  @Input() class = 'form-control';
  @Input() changed: EventEmitter<string> = new EventEmitter<string>();
  @Input() keyboard: 'english' | 'malayalam' | 'manglish';
  @Input() isClearAll = false;
  @ViewChild('input', { static: false }) inputField: ManglishConverterDirective;
  @Input() @HostBinding('tabindex') tabindex = -1;
  @Input() /*@HostBinding('attr.disabled')*/ isDisable = false;
  @Input() /* @HostBinding('class')*/ clas = this.isDisable;
  @ViewChild('keyBoardDiv', { static: false }) keyBoardDivRef: ElementRef;
  defaultInputOptions: IKeyBoradOption = {
    keyboardEnable: true,
    inputarea: 'input',
    keyboardPosition: 'auto'
  };
  @Input() rowSize = 2;
  @Input() colSize = 4;
  @Input() inputOptions: IKeyBoradOption = {
    keyboardEnable: true,
    inputarea: 'input',
    keyboardPosition: 'auto'
  };
  array = [];
  selectedKeys = '';
  caretPos: any;
  numbers = [];
  documentClick: Subscription;
  layout = VIRTUAL_KEYBOARD_LAYOUT;
  isMalayalam: boolean;
  isManglish: boolean;
  inputType = 'malayalam';
  manglishPattern;
  constructor(
    public _elementRef: ElementRef, private renderer: Renderer2, public indicInput: IndicInputDirective) {
    // try {
    this.numbers = _.range(0, VIRTUAL_KEYBOARD_LAYOUT.length, 16);
    const currentUser: CurrentUser = sessionStorage.getItem('CURRENT_USER') ? JSON.parse(sessionStorage.getItem('CURRENT_USER')) : null;
    this.isMalayalam = currentUser?.typingLanguage === 'MALAYALAM' ? true : false;
    this.isManglish = currentUser?.typingLanguage === 'MANGLISH' ? true : false;
    this.setInputType();
    // }
    // catch (e) {
    //   this.isMalayalam = true;
    // }
  }
  @ViewChild(OverlayPanelComponent, { static: false }) keyBoardPanel: OverlayPanelComponent;


  setInputType() {
    if (this.keyboard) {
      this.inputType = this.keyboard;
      this.isMalayalam = this.keyboard === 'malayalam';
      this.isManglish = this.keyboard === 'manglish';
    } else {
      if (this.isMalayalam) {
        this.inputType = 'malayalam';
      } else if (this.isManglish) {
        this.inputType = 'manglish';
      } else {
        this.inputType = 'english';
      }
    }
  }
  handleMlInput(value) {
    this.indicInput.handleMlInput(value)
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.inputOptions = Object.assign(this.defaultInputOptions, this.inputOptions);
    this.indicInput.inputOptions = this.inputOptions;
    if (changes.keyboard) {
      this.setInputType();
      this.indicInput.keyboard = this.keyboard;
      this.indicInput.setInputType();
    }
  }
  ngAfterViewInit(): void {
    this.indicInput.inputField = this.inputField.elementRef;
    this.indicInput.keyBoardPanel = this.keyBoardPanel;
    this.indicInput.keyBoardDivRef = this.keyBoardDivRef;

  }

  clickButton(value, event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    this.insertAtCaretPos(value);
  }
  preventEvent(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();
  }
  openKeyBoard(event) {
    // event.preventDefault();
    // event.stopPropagation();
    // event.stopImmediatePropagation();
    const node = this.indicInput.inputField.nativeElement;
    node.focus();
    this.indicInput.keyBoardPanel = this.keyBoardPanel;
    this.indicInput.keyBoardDivRef = this.keyBoardDivRef;
    this.indicInput.openKeyBoard(event)
  }
  keyPress(value) {
    this.indicInput.keyPress(value)
  }
  onDrag(event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();


    const node = this.inputField.elementRef.nativeElement;
    node.focus();
    node.value = node.value;
    const startPos = node.selectionStart;
    const endPos = node.selectionEnd;
    const scrollTop = node.scrollTop;
    node.selectionStart = startPos + node.length;
    node.selectionEnd = startPos + node.length;
    node.scrollTop = scrollTop;
    node.setSelectionRange(node.value.length, node.value.length);


  }
  insertAtCaretPos(text) {
    this.indicInput.insertAtCaretPos(text);
    const node = this.inputField.elementRef.nativeElement;
    this.selectedKeys = node.value;

  }

  onkeyDown(event: KeyboardEvent) {
    this.indicInput.onkeyDown(event);
    this.isMalayalam = this.indicInput.isMalayalam;
    this.isManglish = this.indicInput.isManglish;
    this.setInputType();

  }

}
export interface IKeyBoradOption {
  keyboardEnable: boolean;
  inputarea: 'input' | 'textarea',
  keyboardPosition: 'auto' | 'top';
}